import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import BackMenuBus from '@/services/BackMenuBus'

import Home from '@/views/Home'
import About from '@/views/About'
import Subjects from '@/views/Subjects'
import Work from '@/views/Work'
import WorkSingle from '@/views/work/Single'
import Research from '@/views/Research'
import ResearchSingle from '@/views/research/Single'
import Designers from '@/views/Designers'
import Designer from '@/views/designers/Designer'
import Tags from '@/views/Tags'
import Tag from '@/views/tags/Tag'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        postData: {
          action: 'home'
        },
        showInHeader: false
      }
    },
    {
      path: '/work',
      name: 'Work',
      component: Work,
      meta: {
        postData: {
          action: 'work'
        },
        showInHeader: true
      }
    },
    {
      path: '/work/:work',
      name: 'Work single',
      component: WorkSingle,
      meta: {
        postData: {
          action: 'work_single'
        },
        showInHeader: false,
        showBackMenu: true
      }
    },
    {
      path: '/research',
      name: 'Research',
      component: Research,
      meta: {
        postData: {
          action: 'research'
        },
        showInHeader: true
      }
    },
    {
      path: '/research/:research',
      name: 'Research single',
      component: ResearchSingle,
      meta: {
        postData: {
          action: 'research_single'
        },
        showInHeader: false,
        showBackMenu: true
      }
    },
    {
      path: '/designers',
      name: 'Designers',
      component: Designers,
      meta: {
        postData: {
          action: 'designers'
        },
        showInHeader: true
      }
    },
    {
      path: '/designers/:designer',
      name: 'Designer',
      component: Designer,
      meta: {
        postData: {
          action: 'designer'
        },
        showInHeader: false
      }
    },
    {
      path: '/subjects',
      name: 'Subjects',
      component: Subjects,
      meta: {
        postData: {
          action: 'subjects'
        },
        showInHeader: true
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        postData: {
          action: 'about'
        },
        showInHeader: true
      }
    },
    {
      path: '/tags',
      name: '(A - Z)',
      component: Tags,
      meta: {
        postData: {
          action: 'tags'
        },
        showInHeader: true
      }
    },
    {
      path: '/tags/:tag',
      name: 'Tag',
      component: Tag,
      meta: {
        postData: {
          action: 'tag'
        },
        showInHeader: false
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.body.classList.add('loading')

  if (from.name === 'Work') {
    store.commit('setWorkScroll', window.scrollY)
  }

  if (from.name === 'Research') {
    store.commit('setResearchScroll', window.scrollY)
  }

  // reset scroll position
  if (to.name !== 'Work single' && to.name !== 'Work') {
    store.commit('setWorkScroll', 0)
  }

  if (to.name !== 'Research single' && to.name !== 'Research') {
    store.commit('setResearchScroll', 0)
  }

  if (to.meta.showBackMenu) {
    BackMenuBus.$emit('showBackMenu', true)
  } else {
    BackMenuBus.$emit('showBackMenu', false)
  }

  next()
})

router.afterEach((to, from) => {
  document.body.classList.remove('loading')

  if (to.meta.showBackMenu) {
    BackMenuBus.$emit('showBackMenu', true)
  } else {
    BackMenuBus.$emit('showBackMenu', false)
  }

  // scroll to top of page
  window.scrollTo(0, 0)
})

export default router
